import { Check, ChevronDown } from "lucide-react";

import { Popover, PopoverContent, PopoverTrigger } from "../../../components/ui/popover";
import type { MontageAccount } from "../lib/accounts";
import { cn, plural } from "../lib/utils";
import { PublicAvatar } from "./PublicAccount";

/**
 * Аккаунт публикации — один или несколько (09.10.2026, Артур): один ролик
 * часто выходит на нескольких каналах, чуть перемонтированный или с другим
 * заголовком. Несколько — значит по публикации на каждый канал.
 *
 * Хотя бы один остаётся всегда: публикация без аккаунта никуда не выходит.
 */
export function AccountsPick({ accounts, value, onChange }: {
  accounts: MontageAccount[];
  value: string[];
  onChange: (ids: string[]) => void;
}) {
  const picked = accounts.filter((a) => value.includes(a.id));
  const label = picked.length === 1 ? picked[0].name : picked.length ? `${picked.length} ${plural(picked.length, ["канал", "канала", "каналов"])}` : "—";
  const toggle = (id: string) => {
    const next = value.includes(id) ? value.filter((x) => x !== id) : [...value, id];
    if (next.length) onChange(accounts.map((a) => a.id).filter((x) => next.includes(x)));
  };
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" className="inline-flex h-8 items-center gap-1.5 rounded-full border bg-background pl-3 pr-2.5 text-[13px] font-medium hover:bg-muted">
          {picked.length === 1 && <PublicAvatar account={picked[0]} className="-ml-2 size-6" />}
          {label}
          <ChevronDown className="size-3.5 text-muted-foreground" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-1" align="start">
        <div className="max-h-80 overflow-y-auto">
          {accounts.map((a) => {
            const on = value.includes(a.id);
            return (
              <button
                key={a.id}
                type="button"
                onClick={() => toggle(a.id)}
                className={cn("flex w-full items-center gap-2.5 rounded-md px-2.5 py-1.5 text-left text-sm hover:bg-muted", on && "font-medium")}
              >
                <span className={cn("grid size-4 shrink-0 place-items-center rounded border", on ? "border-primary bg-primary text-primary-foreground" : "border-input")}>
                  {on && <Check className="size-3" />}
                </span>
                <PublicAvatar account={a} className="size-7" />
                <span className="truncate">{a.name}</span>
              </button>
            );
          })}
        </div>
        <p className="border-t px-2.5 pb-1 pt-2 text-xs text-muted-foreground">
          Несколько каналов — по отдельной публикации на каждый
        </p>
      </PopoverContent>
    </Popover>
  );
}
